import React from "react";
import { Link } from "react-router-dom";
import "../../assets/css/breadcrumb.css";
import MobileFiltergrid from "../Layout/MobileFilter/MobileFiltergrid";

const BreadcrumbSecand = ({ search, setSearch }) => {
  return (
    <section className="breadcrumb-link">
      <div className="container">
        <div className="row mb-4">
          <div className="col-md-8 col-sm-6 col-12 col-my001">
            <div className="Filterbg">
              <h4
                className="text-gray-500 text-sm pt-2 font-normal mt-2"
                style={{ fontSize: "17px" }}
              >
                <span>Home</span> / Affinity Reversible
              </h4>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 col-8 col-my002">

            <div style={{ display: "flex", gap: "8px" }}>

              <div className="justify-content-end align-items-center">

                <div
                  className="input-icon"
                  style={{ marginTop: "4px" }}
                >
                  <i className="bi bi-search font-sm"></i>

                  <input
                    type="text"
                    placeholder="Search Design / Shade..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="form-control form-control-sm bg-white input inputwidth"
                  />

                </div>

              </div>

              <div
                style={{
                  display: "flex",
                  gap: "6px",
                  marginTop: "10px",
                  justifyContent: "flex-end",
                }}
              >
                <div style={{ marginTop: "10px" }}>
                  <MobileFiltergrid />
                </div>

                <Link to="/" className="iconmargin icon-borders-grid">
                  <i className="bi bi-list-task"></i>
                </Link>
              </div>

            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default BreadcrumbSecand;